{
    "PAYMENT_OK_TITLE": "We've received your payment",
    "PAYMENT_OK_DESCRIPTION": "We've correctly received and processed your payment. Plase check your email for a confirmation receipt.",
    "RETURN_HOME": "Return home",
    "PAYMENT_KO_TITLE": "We couldn't process the payment",
    "PAYMENT_KO_DESCRIPTION": "The payment couldn't be completed. Your card has not been charged. Please try again.",
    "RETRY": "Try again"
}